export default __webpack_public_path__ + "static/media/icon_Text_Underscore.2ca176ed.svg";